
<div class="text-center">
    <label v-if="title" class="label">{{ title }}</label><br>
    <font-awesome-icon class="loader" icon="sync-alt" spin />
</div>
